const CHIP_COUNT = 4
const STEP = 5000
const MAX = 100000

const buildMasterList = seeds => {
  const last = seeds[seeds.length - 1]
  const generated = []
  for (let v = last + STEP; v <= MAX; v += STEP) {
    generated.push(v)
  }
  return [...seeds, ...generated]
}

const useChips = ({seeds, toSeeds, toSeedsBase, fromValue, toValue}) => {
  if (!seeds.length) return {fromChips: [], toChips: []}

  const masterList = buildMasterList(seeds)

  const fromChips = masterList.slice(0, CHIP_COUNT)

  let toChips
  if (toSeedsBase && toSeedsBase.length) {
    const filteredSeeds = toSeedsBase.filter(v => v > (fromValue ?? 0))
    const extra = masterList.filter(v => v > (fromValue ?? 0) && !filteredSeeds.includes(v))
    toChips = [...filteredSeeds, ...extra].slice(0, CHIP_COUNT)
  } else if (toSeeds && toSeeds.length) {
    toChips = toSeeds.slice(0, CHIP_COUNT)
  } else {
    const hasToChips = fromValue == null || fromValue < MAX
    toChips = hasToChips ? masterList.filter(v => v > (fromValue ?? 0)).slice(0, CHIP_COUNT) : []
  }

  return {fromChips, toChips}
}

export default useChips
